import type { Finding } from "./Finding";
import { findingsOf } from "./findingsOf";

// Опоздание поздних ключевых предметов в минутах (не меньше 1): от и до. Нет находок — `null`.
export const lateDelayRange = (
  findings: readonly Finding[],
): { from: number; to: number } | null => {
  const delays = findingsOf(findings, "item_bought_late").map((finding) =>
    Math.max(1, Math.round((finding.params.bought_at_s - finding.params.baseline_at_s) / 60)),
  );
  return delays.length === 0 ? null : { from: Math.min(...delays), to: Math.max(...delays) };
};
